import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { styles } from "../../styles/styles.js";
import { StarRating } from "../../components/starrating.js";
import { useAppState } from "../../AppStateContext.js";
import * as motion from "motion/react-client";
import ReactMarkdown from "react-markdown";
import HorizontalBarChart from "./barchart.js";
import { LastTen } from "./lastten.js";
import { HistoryNote } from "./historynote.js";
// winPct survives alongside winRate deliberately. The season and venue rows
// already divide by a real observed count — count_home, or sum(W, L, D) — so
// there is no window/sample distinction to make there and no Partial state to
// render. Only the recent windows were dividing by a constant.
import { fmt, sum, diff, winPct, winRate, winRateValue, stars } from "../../utils/format.js";


const Wins = ({ fixture }) => {
  const [displayMode, setDisplayMode] = useState(2); // 0: Win-Loss, 1: Percentages, 2: Stars (default)
  const { isTutorialMode } = useAppState();
  // const [isAutoCycling, setIsAutoCycling] = useState(true);

  // useEffect(() => {
  //   let interval;
  //   if (isAutoCycling) {
  //     interval = setInterval(() => {
  //       setDisplayMode((prevMode) => (prevMode + 1) % 3);
  //     }, 10000);
  //   }
  //   return () => clearInterval(interval);
  // }, [isAutoCycling]);

  const toggleDisplayMode = () => {
    // setIsAutoCycling(false);
    setDisplayMode((prevMode) => (prevMode + 1) % 3);
  };

  const AnimatedCell = ({ children }) => (
    <motion.div
      key={displayMode}
      initial={{ opacity: 0, x: -100 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{
        duration: 0.5,
        scale: { type: "spring", damping: 10, stiffness: 100, bounce: 0.5 },
      }}>
      {children}
    </motion.div>
  );

  if (!fixture.recent) return null;


  return (
    <>
      {displayMode !== 2 && (
      <Table bordered className="main">
        <tbody>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.Cells}>
              Wins
            </td>
            <td className="Cells" style={styles.Cells}></td>
            <td className="Cells" style={styles.Cells}></td>
          </tr>
          <tr>
            <td className="Cells" style={styles.Cells}></td>
            <td className="Cells" style={styles.column_1}>
              {fixture.home_team}
            </td>
            <td className="Cells" style={styles.column_1}>
              {fixture.away_team}
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Last 3
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
                {displayMode === 0 ? (
                  `${fmt(fixture.recent.home_win_3, 0)} - ${fmt(fixture.recent.home_loss_3, 0)}${
                    isSupportedSport(fixture) ? ` - ${fmt(fixture.recent.home_draws_3, 0)}` : ""
                  }`
                ) : displayMode === 1 ? (
                  winRate(fixture.recent.home_win_3, fixture.recent.home_draws_3, fixture.recent.home_games_sample_3, 3)
                ) : (
                  <StarRating
                    rating={stars(
                      winRateValue(fixture.recent.home_win_3, fixture.recent.home_draws_3, fixture.recent.home_games_sample_3, 3),
                      winRateValue(fixture.recent.away_win_3, fixture.recent.away_draws_3, fixture.recent.away_games_sample_3, 3)
                    )}
                  />
                )}
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
                {displayMode === 0 ? (
                  `${fmt(fixture.recent.away_win_3, 0)} - ${fmt(fixture.recent.away_loss_3, 0)}${
                    isSupportedSport(fixture) ? ` - ${fmt(fixture.recent.away_draws_3, 0)}` : ""
                  }`
                ) : displayMode === 1 ? (
                  winRate(fixture.recent.away_win_3, fixture.recent.away_draws_3, fixture.recent.away_games_sample_3, 3)
                ) : (
                  <StarRating
                    rating={stars(
                      winRateValue(fixture.recent.away_win_3, fixture.recent.away_draws_3, fixture.recent.away_games_sample_3, 3),
                      winRateValue(fixture.recent.home_win_3, fixture.recent.home_draws_3, fixture.recent.home_games_sample_3, 3)
                    )}
                  />
                )}
              </AnimatedCell>
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Last 5
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
                {displayMode === 0 ? (
                  `${fmt(fixture.recent.home_win_5, 0)} - ${fmt(fixture.recent.home_loss_5, 0)}${
                    isSupportedSport(fixture) ? ` - ${fmt(fixture.recent.home_draws_5, 0)}` : ""
                  }`
                ) : displayMode === 1 ? (
                  winRate(fixture.recent.home_win_5, fixture.recent.home_draws_5, fixture.recent.home_games_sample_5, 5)
                ) : (
                  <StarRating
                    rating={stars(
                      winRateValue(fixture.recent.home_win_5, fixture.recent.home_draws_5, fixture.recent.home_games_sample_5, 5),
                      winRateValue(fixture.recent.away_win_5, fixture.recent.away_draws_5, fixture.recent.away_games_sample_5, 5)
                    )}
                  />
                )}
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
                {displayMode === 0 ? (
                  `${fmt(fixture.recent.away_win_5, 0)} - ${fmt(fixture.recent.away_loss_5, 0)}${
                    isSupportedSport(fixture) ? ` - ${fmt(fixture.recent.away_draws_5, 0)}` : ""
                  }`
                ) : displayMode === 1 ? (
                  winRate(fixture.recent.away_win_5, fixture.recent.away_draws_5, fixture.recent.away_games_sample_5, 5)
                ) : (
                  <StarRating
                    rating={stars(
                      winRateValue(fixture.recent.away_win_5, fixture.recent.away_draws_5, fixture.recent.away_games_sample_5, 5),
                      winRateValue(fixture.recent.home_win_5, fixture.recent.home_draws_5, fixture.recent.home_games_sample_5, 5)
                    )}
                  />
                )}
              </AnimatedCell>
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Last 10
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
                {displayMode === 0 ? (
                  `${fmt(fixture.recent.home_win_10, 0)} - ${fmt(fixture.recent.home_loss_10, 0)}${
                    isSupportedSport(fixture) ? ` - ${fmt(fixture.recent.home_draws_10, 0)}` : ""
                  }`
                ) : displayMode === 1 ? (
                  winRate(fixture.recent.home_win_10, fixture.recent.home_draws_10, fixture.recent.home_games_sample_10, 10)
                ) : (
                  <StarRating
                    rating={stars(
                      winRateValue(fixture.recent.home_win_10, fixture.recent.home_draws_10, fixture.recent.home_games_sample_10, 10),
                      winRateValue(fixture.recent.away_win_10, fixture.recent.away_draws_10, fixture.recent.away_games_sample_10, 10)
                    )}
                  />
                )}
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
                {displayMode === 0 ? (
                  `${fmt(fixture.recent.away_win_10, 0)} - ${fmt(fixture.recent.away_loss_10, 0)}${
                    isSupportedSport(fixture) ? ` - ${fmt(fixture.recent.away_draws_10, 0)}` : ""
                  }`
                ) : displayMode === 1 ? (
                  winRate(fixture.recent.away_win_10, fixture.recent.away_draws_10, fixture.recent.away_games_sample_10, 10)
                ) : (
                  <StarRating
                    rating={stars(
                      winRateValue(fixture.recent.away_win_10, fixture.recent.away_draws_10, fixture.recent.away_games_sample_10, 10),
                      winRateValue(fixture.recent.home_win_10, fixture.recent.home_draws_10, fixture.recent.home_games_sample_10, 10)
                    )}
                  />
                )}
              </AnimatedCell>
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Season
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
                {displayMode === 0 ? (
                  `${fmt(fixture.stats?.home_wins, 0)} - ${fmt(fixture.stats?.home_losses, 0)}${
                    isSupportedSport(fixture) ? ` - ${fmt(fixture.stats?.home_draws, 0)}` : ""
                  }`
                ) : displayMode === 1 ? (
                  fmt(winPct(fixture.stats?.home_wins, fixture.stats?.home_draws, fixture.stats?.count_home), 1, { suffix: "%" })
                ) : (
                  <StarRating
                    rating={stars(
                      winPct(fixture.stats?.home_wins, fixture.stats?.home_draws, fixture.stats?.count_home),
                      winPct(fixture.stats?.away_wins, fixture.stats?.away_draws, fixture.stats?.count_away)
                    )}
                  />
                )}
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
                {displayMode === 0 ? (
                  `${fmt(fixture.stats?.away_wins, 0)} - ${fmt(fixture.stats?.away_losses, 0)}${
                    isSupportedSport(fixture) ? ` - ${fmt(fixture.stats?.away_draws, 0)}` : ""
                  }`
                ) : displayMode === 1 ? (
                  fmt(winPct(fixture.stats?.away_wins, fixture.stats?.away_draws, fixture.stats?.count_away), 1, { suffix: "%" })
                ) : (
                  <StarRating
                    rating={stars(
                      winPct(fixture.stats?.away_wins, fixture.stats?.away_draws, fixture.stats?.count_away),
                      winPct(fixture.stats?.home_wins, fixture.stats?.home_draws, fixture.stats?.count_home)
                    )}
                  />
                )}
              </AnimatedCell>
            </td>
          </tr>
          {shouldShowLastSeason(fixture) && (
            <tr style={styles.Cells}>
              <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
                Last Season
              </td>
              <td className="Cells" style={styles.Cells}>
                <AnimatedCell>
                  {displayMode === 0 ? (
                    `${fmt(fixture.stats?.home_wins_last, 0)} - ${fmt(fixture.stats?.home_losses_last, 0)}${
                      isSupportedSport(fixture) ? ` - ${fmt(fixture.stats?.home_draws_last, 0)}` : ""
                    }`
                  ) : displayMode === 1 ? (
                    fmt(winPct(
                      fixture.stats?.home_wins_last,
                      fixture.stats?.home_draws_last,
                      fixture.stats?.count_home_last
                    ), 1, { suffix: "%" })
                  ) : (
                    <StarRating
                      rating={stars(
                        winPct(fixture.stats?.home_wins_last, fixture.stats?.home_draws_last, fixture.stats?.count_home_last),
                        winPct(fixture.stats?.away_wins_last, fixture.stats?.away_draws_last, fixture.stats?.count_away_last)
                      )}
                    />
                  )}
                </AnimatedCell>
              </td>
              <td className="Cells" style={styles.Cells}>
                <AnimatedCell>
                  {displayMode === 0 ? (
                    `${fmt(fixture.stats?.away_wins_last, 0)} - ${fmt(fixture.stats?.away_losses_last, 0)}${
                      isSupportedSport(fixture) ? ` - ${fmt(fixture.stats?.away_draws_last, 0)}` : ""
                    }`
                  ) : displayMode === 1 ? (
                    fmt(winPct(
                      fixture.stats?.away_wins_last,
                      fixture.stats?.away_draws_last,
                      fixture.stats?.count_away_last
                    ), 1, { suffix: "%" })
                  ) : (
                    <StarRating
                      rating={stars(
                        winPct(fixture.stats?.away_wins_last, fixture.stats?.away_draws_last, fixture.stats?.count_away_last),
                        winPct(fixture.stats?.home_wins_last, fixture.stats?.home_draws_last, fixture.stats?.count_home_last)
                      )}
                    />
                  )}
                </AnimatedCell>
              </td>
            </tr>
          )}
          <tr style={{ ...styles.Cells, borderTop: "0", borderBottom: "0" }}>
            <td className="Cells" style={{ ...styles.Cells, borderTop: "0", borderBottom: "0" }} colSpan="3">
              &nbsp;
            </td>
          </tr>
          <tr style={{ ...styles.Cells, borderTop: "0", borderBottom: "0" }}>
            <td className="Cells" style={{ ...styles.Cells, borderTop: "0", borderBottom: "0" }} colSpan="3">
              &nbsp;
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Home
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
                {displayMode === 0 ? (
                  `${fmt(fixture.stats?.home_home_wins, 0)} - ${fmt(fixture.stats?.home_home_losses, 0)}${
                    isSupportedSport(fixture) ? ` - ${fmt(fixture.stats?.home_home_draws, 0)}` : ""
                  }`
                ) : displayMode === 1 ? (
                  fmt(winPct(
                    fixture.stats?.home_home_wins,
                    fixture.stats?.home_home_draws,
                    sum(fixture.stats?.home_home_wins, fixture.stats?.home_home_losses, fixture.stats?.home_home_draws)
                  ), 1, { suffix: "%" })
                ) : (
                  <StarRating
                    rating={stars(
                      winPct(
                        fixture.stats?.home_home_wins,
                        fixture.stats?.home_home_draws,
                        sum(fixture.stats?.home_home_wins, fixture.stats?.home_home_losses, fixture.stats?.home_home_draws)
                      ),
                      winPct(
                        fixture.stats?.away_away_wins,
                        fixture.stats?.away_away_draws,
                        sum(fixture.stats?.away_away_wins, fixture.stats?.away_away_losses, fixture.stats?.away_away_draws)
                      )
                    )}
                  />
                )}
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}></td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
              Away
            </td>
            <td className="Cells" style={styles.Cells}></td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
                {displayMode === 0 ? (
                  `${fmt(fixture.stats?.away_away_wins, 0)} - ${fmt(fixture.stats?.away_away_losses, 0)}${
                    isSupportedSport(fixture) ? ` - ${fmt(fixture.stats?.away_away_draws, 0)}` : ""
                  }`
                ) : displayMode === 1 ? (
                  fmt(winPct(
                    fixture.stats?.away_away_wins,
                    fixture.stats?.away_away_draws,
                    sum(fixture.stats?.away_away_wins, fixture.stats?.away_away_losses, fixture.stats?.away_away_draws)
                  ), 1, { suffix: "%" })
                ) : (
                  <StarRating
                    rating={stars(
                      winPct(
                        fixture.stats?.away_away_wins,
                        fixture.stats?.away_away_draws,
                        sum(fixture.stats?.away_away_wins, fixture.stats?.away_away_losses, fixture.stats?.away_away_draws)
                      ),
                      winPct(
                        fixture.stats?.home_home_wins,
                        fixture.stats?.home_home_draws,
                        sum(fixture.stats?.home_home_wins, fixture.stats?.home_home_losses, fixture.stats?.home_home_draws)
                      )
                    )}
                  />
                )}
              </AnimatedCell>
            </td>
          </tr>
          {shouldShowLastSeason(fixture) && (
            <>
              <tr style={styles.Cells}>
                <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
                  Home Last Season
                </td>
                <td className="Cells" style={styles.Cells}>
                  <AnimatedCell>
                    {displayMode === 0 ? (
                      `${fmt(fixture.stats?.home_home_wins_last, 0)} - ${fmt(fixture.stats?.home_home_losses_last, 0)}${
                        isSupportedSport(fixture) ? ` - ${fmt(fixture.stats?.home_home_draws_last, 0)}` : ""
                      }`
                    ) : displayMode === 1 ? (
                      fmt(winPct(
                        fixture.stats?.home_home_wins_last,
                        fixture.stats?.home_home_draws_last,
                        sum(fixture.stats?.home_home_wins_last, fixture.stats?.home_home_losses_last, fixture.stats?.home_home_draws_last)
                      ), 1, { suffix: "%" })
                    ) : (
                      <StarRating
                        rating={stars(
                          winPct(
                            fixture.stats?.home_home_wins_last,
                            fixture.stats?.home_home_draws_last,
                            sum(fixture.stats?.home_home_wins_last, fixture.stats?.home_home_losses_last, fixture.stats?.home_home_draws_last)
                          ),
                          50
                        )}
                      />
                    )}
                  </AnimatedCell>
                </td>
                <td className="Cells" style={styles.Cells}></td>
              </tr>
              <tr style={styles.Cells}>
                <td className="Cells" style={styles.column_1} onClick={toggleDisplayMode}>
                  Away Last Season
                </td>
                <td className="Cells" style={styles.Cells}></td>
                <td className="Cells" style={styles.Cells}>
                  <AnimatedCell>
                    {displayMode === 0 ? (
                      `${fmt(fixture.stats?.away_away_wins_last, 0)} - ${fmt(fixture.stats?.away_away_losses_last, 0)}${
                        isSupportedSport(fixture) ? ` - ${fmt(fixture.stats?.away_away_draws_last, 0)}` : ""
                      }`
                    ) : displayMode === 1 ? (
                      fmt(winPct(
                        fixture.stats?.away_away_wins_last,
                        fixture.stats?.away_away_draws_last,
                        sum(fixture.stats?.away_away_wins_last, fixture.stats?.away_away_losses_last, fixture.stats?.away_away_draws_last)
                      ), 1, { suffix: "%" })
                    ) : (
                      <StarRating
                        rating={stars(
                          winPct(
                            fixture.stats?.away_away_wins_last,
                            fixture.stats?.away_away_draws_last,
                            sum(fixture.stats?.away_away_wins_last, fixture.stats?.away_away_losses_last, fixture.stats?.away_away_draws_last)
                          ),
                          50
                        )}
                      />
                    )}
                  </AnimatedCell>
                </td>
              </tr>
            </>
          )}
        </tbody>
      </Table>
      )}


  {displayMode === 2 && (
    <div style={{
      width: "100%",
      marginTop: "0px",
      alignSelf: "flex-start"
    }}>
    <Table bordered className="main" onClick={toggleDisplayMode}>
      <tbody>
        <tr style={styles.Cells}>
          <td className="Cells" style={styles.column_1}>
            Wins
          </td>
          <td className="Cells" style={styles.Cells}></td>
          <td className="Cells" style={styles.Cells}></td>
        </tr>
        <tr>
          <td className="Cells" style={{...styles.column_1, width: "5%"}}>
          </td>
          <td className="Cells" style={{...styles.column_1, width: "25%"}}>
            {fixture.home_team}
          </td>
          <td className="Cells" style={{...styles.column_1, width: "25%"}}>
            {fixture.away_team}
          </td>
        </tr>
      </tbody>
    </Table>
    {/* rawData feeds Math.max and a Recharts domain — every entry stays
        number | null. An em-dash here would produce NaN and no axis. */}
    <HorizontalBarChart
      shortNames={["3G", "5G", "10G", "SN", "HA"]}
      rawData={[
        diff(
          winRateValue(fixture.recent.away_win_3, fixture.recent.away_draws_3, fixture.recent.away_games_sample_3, 3),
          winRateValue(fixture.recent.home_win_3, fixture.recent.home_draws_3, fixture.recent.home_games_sample_3, 3)
        ),
        diff(
          winRateValue(fixture.recent.away_win_5, fixture.recent.away_draws_5, fixture.recent.away_games_sample_5, 5),
          winRateValue(fixture.recent.home_win_5, fixture.recent.home_draws_5, fixture.recent.home_games_sample_5, 5)
        ),
        diff(
          winRateValue(fixture.recent.away_win_10, fixture.recent.away_draws_10, fixture.recent.away_games_sample_10, 10),
          winRateValue(fixture.recent.home_win_10, fixture.recent.home_draws_10, fixture.recent.home_games_sample_10, 10)
        ),
        diff(
          winPct(fixture.stats?.away_wins, fixture.stats?.away_draws, fixture.stats?.count_away),
          winPct(fixture.stats?.home_wins, fixture.stats?.home_draws, fixture.stats?.count_home)
        ),
        diff(
          winPct(fixture.stats?.away_away_wins, fixture.stats?.away_away_draws, sum(fixture.stats?.away_away_wins, fixture.stats?.away_away_losses, fixture.stats?.away_away_draws)),
          winPct(fixture.stats?.home_home_wins, fixture.stats?.home_home_draws, sum(fixture.stats?.home_home_wins, fixture.stats?.home_home_losses, fixture.stats?.home_home_draws))
        )
      ]}
      names={["Last 3", "Last 5", "Last 10", "Season", "Home and Away"]}
      onClick={toggleDisplayMode}
    />
  </div>
)}

      <div style={{ height: "5vh" }}></div>
      <HistoryNote fixture={fixture} />
      <div style={{ height: "2vh" }}></div>
      <LastTen
        results={Array(10)
          .fill()
          .map((_, i) => fixture.recent[`home_${i + 1}_did_win`])
          .reverse()}
        title={fixture.home_team + ' wins'}
      />
      <div style={{ height: "2vh" }}></div>
      <LastTen
        results={Array(10)
          .fill()
          .map((_, i) => fixture.recent[`away_${i + 1}_did_win`])
          .reverse()}
        title={fixture.away_team + ' wins'}
      />
      <div style={{ height: "5vh" }}></div>

      <div style={{ marginTop: "20px" }}>
        {fixture.box_score && (
          <ul
            style={{
              listStyleType: "none",
              padding: 0,
              margin: 0,
              fontSize: 'clamp(10px, calc(7px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)'
            }}>
            <ReactMarkdown>{fixture.box_score['wins_stats']}</ReactMarkdown>
          </ul>
        )}
      </div>
    </>
  );
};

// These functions should be moved to a utility file
function shouldShowLastSeason(fixture) {
  if (fixture.league === "NFL" || fixture.league === "NHL") {
    return true;
  }
  // Unknown season progress is not early-season. Showing a "Last Season" row we
  // cannot justify is worse than omitting it, and the old unguarded deref threw.
  return fixture.ratings?.progress != null && fixture.ratings.progress < 0.15;
}

function isSupportedSport(fixture) {
  const supportedSports = ["Hockey", "Soccer", "RugbyLeague", "AussieRules"];
  return supportedSports.includes(fixture.sport);
}

export default Wins;
